import { INVALID_BARCODE } from "../action/scanBarcodeAction";
import { COMMON_ACTIONS } from "../constants/ActionType";

export const ScanBarcodeReducer = (state, action) => {
  switch (action.type) {
    case COMMON_ACTIONS.LOADING:
      return {
        ...state,
        notification: undefined,
        isLoading: true,
        error: false,
      };
    case INVALID_BARCODE:
      return {
        ...state,
        notification: undefined,
        isLoading: false,
        error: true,
      };
    case COMMON_ACTIONS.SERVER_FAILURE:
      return {
        ...state,
        notification: undefined,
        isLoading: false,
        error: true,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/scanBarcode/reducer/ScanBarcodeReducer.js